import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled", "onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "rating-stars__button-fill",
    d: "M16 5L20 10L26 13L22 18L22 24L16 23L10 24L10 18L6 13L12 10Z",
    fill: "transparent"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "rating-stars__button-outline",
    d: "M16 4C16.9217 4 17.778 4.47592 18.2646 5.25863L20.8191 9.3671L25.5158 10.5269C26.4106 10.7479 27.1279 11.4152 27.4127 12.2918C27.6975 13.1683 27.5095 14.1298 26.9155 14.8345L23.7974 18.5335L24.1457 23.3588C24.2121 24.2781 23.7991 25.1665 23.0534 25.7082C22.3078 26.2499 21.3353 26.3682 20.4815 26.0211L16 24.1987L11.5185 26.0211C10.6647 26.3682 9.69222 26.2499 8.94658 25.7082C8.20094 25.1665 7.78791 24.2781 7.85426 23.3588L8.20257 18.5335L5.08454 14.8345C4.49053 14.1298 4.30252 13.1683 4.58733 12.2918C4.87213 11.4152 5.58938 10.7479 6.48416 10.5269L11.1809 9.3671L13.7354 5.25863C14.222 4.47592 15.0783 4 16 4ZM12.873 11.696L7.12348 13.1158L10.9404 17.644L10.514 23.5508L16 21.32L21.486 23.5508L21.0596 17.644L24.8765 13.1158L19.127 11.696L16 6.66667L12.873 11.696Z",
    fill: "#9CA3B6"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rating-stars", {
      'rating-stars_selected-all': _ctx.modelValue >= 4
    }])
  }, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
      return _createElementVNode("button", {
        key: index,
        class: _normalizeClass(["rating-stars__button", {
        'rating-stars__button_selected': index <= _ctx.modelValue
      }]),
        disabled: _ctx.disabled,
        onClick: ($event: any) => (_ctx.buttonClickHandler(index))
      }, _hoisted_3, 10, _hoisted_1)
    }), 64))
  ], 2))
}